import React from 'react';
import { DropdownMenuContainer } from 'components/DropdownMenu/DropdownMenuContainer';
import classNames from 'classnames';
import { NEW_EPISODE_MENU_ITEMS } from '../../constants';
import styles from '../../../../shared/Button/styles.sass';

const NewEpisodeNav = () => {
  const cx = classNames(styles.button, styles.onDark);
  return (
    <DropdownMenuContainer
      buttonStyles={cx}
      renderPressableContent="New Episode"
      shouldShowDistributionItem={false}
      menuItems={NEW_EPISODE_MENU_ITEMS}
      flyoutBorderRadius={16}
      flyoutMarginTop={4}
      flyoutPaddingTopBottom={0}
      flyoutWidth={278}
      alignFlyout="bottom"
    />
  );
};

export { NewEpisodeNav };
